import {gsap} from "gsap";

const Extender = {

    init() {
        this.el = $('[component="Extender"]');
        if (!this.el.length) return;

        this.el.each((i, el) => {
            this.prepare($(el));
        })
    },

    prepare(el) {
        if (el.innerHeight() <= parseInt(el.attr('max-height')) + 50) return;

        $('<div class="handle"></div>')
            .attr('icon', el.attr('icon-open'))
            .html('<span>' + el.attr('text-open') + '</span>')
            .appendTo(el);

        el.css('height', el.attr('max-height'));
        this.bind(el);
    },

    bind(component) {
        component.find('.handle').click((evt) => {
            const el = $(evt.currentTarget);
            if (el.is('.active')) {
                this.hide(component);
            } else {
                this.show(component);
            }
        })
    },

    show(el) {
        el.find('.handle').addClass('active')
            .attr('icon', el.attr('icon-close'))
            .html('<span>' + el.attr('text-close') + '</span>')

        gsap.set(el, {height: 'auto'})
        gsap.from(el, {height: el.attr('max-height'), clearProps: true})
    },

    hide(el) {
        el.find('.handle').removeClass('active')
            .attr('icon', el.attr('icon-open'))
            .html('<span>' + el.attr('text-open') + '</span>')

        gsap.to(el, {height: el.attr('max-height')})
    }
}

export default Extender;